import { STATIC_ENDPOINT } from "@/config/endpoint/endpoint";

export const images = {
  // logoOnly: logoOnly,
  reportMenuIcon: '/assets/report-icon.png',
  keywordMenuIcon: '/assets/keyword-icon.png',
  templateMenuIcon: '/assets/template-icon.png',
  communityMenuIcon: '/assets/community-icon.png',
  syncMenuIcon: '/assets/sync-icon.png',
  errorImageIcon: '/assets/error-image.png',
  logo: '/assets/logo-512.webp',
  instructionImage1: '/assets/instructions/instruction_1.png',
  instructionImage2: '/assets/instructions/instruction_2.png',
  instructionImage3: '/assets/instructions/instruction_3.png',
  featureImage1: '/assets/feature1.png',
  featureImage2: '/assets/feature2.png',
  featureVideo3: '/assets/feature3.webm',
  featureImage4: '/assets/feature4.png',
  kakaotalkImage: '/assets/kakaotalk-logo.png',
  michelinStar: '/assets/logo-michelin.svg',
  blueRibbon: '/assets/logo-blueribbon.svg',
  googleMap: '/assets/logo-google-map.svg',
  naverMap: '/assets/logo-naver-map.webp',
  wechat: '/assets/logo-wechat.svg',
  line: '/assets/logo-line.svg',
  mainBackgroundImage: '/assets/background.webp'
};

export const lottie = {
  search: '/assets/searching.json'
}


export const BLUR_URL =
  'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';


export const mainImages = [1,2,3,4,5,6,7,8].map((index) => `${STATIC_ENDPOINT}/public/main/${index}.webp`)


export const getUnifiedRestaurantsImages = (id: number, officialImages: string[], userImages: string[]) => {
  return [
    ...officialImages.map((image) => `${STATIC_ENDPOINT}/restaurants/${id}/officialImages/${image}`),
    ...userImages.map((image) => `${STATIC_ENDPOINT}/restaurants/${id}/userImages/${image}`)
  ]
}

export const getUnifiedAttractionsImages = (id: number, images: string[]) => {
  return images?.map((image) => `${STATIC_ENDPOINT}/attractions/${id}/${image}`)
}